<template>
  <v-tooltip
    top
  >
    <template #activator="{ on, attrs }">
      <div
        class="container-info py-2 text-center"
        :class="{
          'is_current' : cycle.is_current
        }"
        v-bind="attrs"
        v-on="on"
        @click="onClick"
      >
        <p
          class="challenge-info-text font-weight-bolder"
          :class="{
            'past-text-color': !cycle.is_current && cycle.started && !(cycle.challenge && cycle.challenge_result_released),
            'inative-text-color': !cycle.is_current && !cycle.started && !(cycle.challenge && cycle.challenge_result_released),
            'white--text' : cycle.is_current,
            'challenge--text ' : !cycle.is_current && cycle.started && cycle.challenge && cycle.challenge_result_released
          }"
        >
          {{ cycle.challenge && cycle.challenge_result_released && cycle.started ? `${cycle.performance}%` : '-' }}
        </p>
        <p
          class="challenge-sub-text font-weight-bold"
          :class="{
            'past-text-color': !cycle.is_current && cycle.started,
            'inative-text-color': !cycle.is_current && !cycle.started,
            'white--text' : cycle.is_current ,
          }"
        >
          Desafio
        </p>
      </div>
    </template>
    <div v-if="!cycle.started">
      <p>
        Este ciclo de estudos ainda não está disponível
      </p>
    </div>
    <div v-else-if="!cycle.is_finished && !cycle.challenge_released && !cycle.show_result">
      <p>
        O desafio deste ciclo de estudos ainda não está disponível
      </p>
    </div>
    <div v-else-if="!cycle.challenge || !cycle.challenge.finished_at">
      <p>
        Você não realizou o desafio do ciclo
      </p>
    </div>
    <div v-else-if="!cycle.is_finished && !cycle.challenge_result_released">
      <p>
        Seu desafio foi concluído e seu resultado será liberado no dia {{ $moment(cycle.release_challenge_result_at).format("DD/MM") }}
      </p>
    </div>
    <div v-else>
      <p>Desafio: <span class="font-weight-bold">{{ cycle.challenge.count_questions }} questões</span></p>
      <p>Desempenho: <span class="font-weight-bold">{{ cycle.performance }}%</span></p>
      <p>Acertos: <span class="font-weight-bold">{{ cycle.challenge.hits }}/{{ cycle.challenge.count_questions }}</span></p>
    </div>
  </v-tooltip>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { studyNowRouteName } from '../../../constants/routes';
export default {
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    },
    data(){
        return {
          studyNowRouteName
        }
    },
    methods: {
      ...mapActions(['accessChallenge']),
      ...mapMutations(['SET_CYCLE']),
        onClick(){
          if(this.cycle.challenge && this.cycle.challenge_result_released){
            this.SET_CYCLE(this.cycle)
            this.$router.push({ name: studyNowRouteName })
            this.accessChallenge({id: this.cycle.challenge.id, cycle_config_id: this.cycle.id})
          }
        }
    }
}
</script>
<style scoped>
  .past-text-color {
    color: #767676
  }.inative-text-color {
    color: #928C99
  }
  .challenge-info-text {
    font-size: 14px;
    @media screen and (min-width: 768px) {
      font-size: 21px;
    }
  }

  .challenge-sub-text{
    font-size:10px;
    @media screen and (min-width: 768px) {
      font-size: 15px;
    }
  }
  p{
    margin: 0
  }
</style>

